import { LogEntry } from '../types';
import { timestamp } from '../utils/formatters';

export const BUILD_LOG_SEQUENCE: LogEntry[] = [
  { type: 'accent',  text: '━━━ Build Session Started ━━━' },
  { type: 'accent',  text: '▶ Starting build pipeline...' },
  { type: 'info',    text: '  [1/6] Compiling JavaScript bundle...' },
  { type: 'info',    text: '  [2/6] Running Metro bundler...' },
  { type: 'success', text: '✓ Bundle compiled: 2.1MB (minified)' },
  { type: 'info',    text: '  [3/6] Generating resources...' },
  { type: 'info',    text: '  [4/6] Assembling Gradle project...' },
  { type: 'success', text: '✓ Gradle task :app:assembleRelease SUCCESS' },
  { type: 'info',    text: '  [5/6] Signing APK with release keystore...' },
  { type: 'success', text: '✓ APK signed successfully' },
  { type: 'info',    text: '  [6/6] Aligning APK (zipalign)...' },
  { type: 'success', text: '✓ BUILD SUCCESSFUL in 47s' },
  { type: 'accent',  text: '  Output: /build/outputs/apk/release/app-release.apk (8.3MB)' },
];

type ProgressCallback = (progress: number, phase: string) => void;
type LogCallback     = (entry: LogEntry) => void;
type DoneCallback    = () => void;

const PHASES = ['Bundling JS', 'Compiling Resources', 'Assembling APK', 'Signing', 'Optimizing'];

export function startBuildSimulation(
  onProgress: ProgressCallback,
  onLog: LogCallback,
  onDone: DoneCallback
): () => void {
  let progress = 0;
  let phaseIdx = 0;
  let logIdx = 0;
  let cancelled = false;

  const progressInterval = setInterval(() => {
    if (cancelled) return;
    progress += Math.random() * 3.5 + 1;
    if (progress >= 100) {
      progress = 100;
      clearInterval(progressInterval);
      setTimeout(() => { if (!cancelled) onDone(); }, 600);
    }
    const pi = Math.min(Math.floor((progress / 100) * PHASES.length), PHASES.length - 1);
    if (pi !== phaseIdx) { phaseIdx = pi; }
    onProgress(Math.min(progress, 100), PHASES[phaseIdx]);
  }, 380);

  const logInterval = setInterval(() => {
    if (cancelled || logIdx >= BUILD_LOG_SEQUENCE.length) {
      clearInterval(logInterval);
      return;
    }
    onLog({ ...BUILD_LOG_SEQUENCE[logIdx], timestamp: timestamp() });
    logIdx++;
  }, 420);

  return () => {
    cancelled = true;
    clearInterval(progressInterval);
    clearInterval(logInterval);
  };
}
